
  import {Vue, Component, Prop, Watch} from "vue-property-decorator";
  import {ProfitReportStandardDto} from "@/api/appService";
  import detail from "@/views/pays/payroll/socialSecurityAssign/detail.vue";

  interface RowItem {
    strong: boolean;
    level: number,
    itemName: string;
    totalAmount: number;
    values: number[]
  };

  interface ItemDetail {
    /**
     * 此项的12个月的总和
     */
    totalAmount:number;
    /**
     * 各月的金额
     */
    monthValues:{[key:number]:number};
    children:{[key:number]:ItemDetail}
  }

  interface PartialItems {
    /**
     * 各个项目的明细
     */
    items:{[key:string]:ItemDetail};
    /**
     * 所有项目的按12个月分别汇总的统计
     */
    totalOfMonth:number[],
    /**
     * 累计总额
     */
    total:number
  }

  function formatAmount(value:number){
    if(value === 0){
      return '0'
    } else if(isNaN(value)){
      return '0';
    } else {
      return value.toFixed(2);
    }
  }


  @Component({name: 'ReportTable',filters:{
    formatAmount
    }})
  export default class ReportTable extends Vue {

    @Prop({required: true})
    dataList!: ProfitReportStandardDto[];

    tableRows:RowItem[] = [];

    dataReady = false;

    created() {
      // 统计

    }

    @Watch('dataList')
    onDataListChange(newValue:ProfitReportStandardDto[]){
      console.log('onDataListChange');
      if(newValue){
        this.tableRows = this.parse();
        this.dataReady = true;
      } else {
        this.dataReady = false;
      }
    }


    parse() {
      let partialOfIncome = this.parseOfCategory('Income');
      let partialOfCost = this.parseOfCategory('Cost');

      let rows:RowItem[] = [];

      // 构建：收入总额
      rows.push({
        values:partialOfIncome.totalOfMonth,
        totalAmount:partialOfIncome.total,
        level:0,
        strong:true,
        itemName:'收入总额'});

      rows = rows.concat(this.convertItemsToRowItems(partialOfIncome.items,1));

      // 构建成本
      rows.push({
        values:partialOfCost.totalOfMonth,
        totalAmount:partialOfCost.total,
        level:0,
        strong:true,
        itemName:'成本总额'
      });

      rows = rows.concat(this.convertItemsToRowItems(partialOfCost.items,1));

      // 计算总利润

      let profitValues:number[] = [];

      for(let month = 1;month<=12;month++){
        profitValues.push(partialOfIncome.totalOfMonth[month-1] - partialOfCost.totalOfMonth[month-1]);
      }

      rows.push({
        values: profitValues,
        totalAmount: partialOfIncome.total - partialOfCost.total,
        strong:true,
        level:0,
        itemName:'总利润'
      });

      return rows;

    }

    convertItemsToRowItems(items:{[key:string]:ItemDetail},level:number){
      let rows:RowItem[] = [];
      for(let itemKey in items){
        let item = items[itemKey];
        rows.push({
          values: this.convertMonthValuesToArray(item.monthValues!),
          itemName: itemKey,
          level:level,
          totalAmount: item.totalAmount,
          strong:false
        });

        if(item.children){
          rows = rows.concat(this.convertItemsToRowItems(item.children,level+1));
        }

      }
      return rows;
    }

    parseOfCategory(category:string){
      let categoryRecords = this.dataList.filter(s => s.category === category);
      let categoryItems = this.buildChildren(categoryRecords.filter(s => !s.parentId), categoryRecords);
      this.updateTotalByMonth(categoryItems??{});

      let totalOfMonth:{[key:number]:number} = {};
      let total = 0;
      for(let month= 1;month<=12;month++){
        totalOfMonth[month] = 0;

        for(let itemKey in categoryItems){
          let currentItem = categoryItems[itemKey];
          let value = currentItem.monthValues[month] || 0;
          totalOfMonth[month] += (value);
          total += value;
        }

      }

      let monthValues = [];
      for(let month = 1;month<=12;month++){
        monthValues.push(totalOfMonth[month]??0);
      }

      let result:PartialItems = {
        items: categoryItems!,
        total:total,
        totalOfMonth:monthValues
      };

      return result;

    }

    updateTotalByMonth(categoryItems:{[key:string]:ItemDetail}){
      for(let itemKey in categoryItems){
        const item = categoryItems[itemKey];
        item.totalAmount = 0;
        for(let month=1;month<=12;month++){
          const monthValue = item.monthValues[month];
          if(monthValue){
            item.totalAmount += monthValue;
          }
        }

        if(item.children){
          this.updateTotalByMonth(item.children);
        }
      }

    }



    convertMonthValuesToArray(monthValues:{[key:number]:number}){
      let result:number[] = [];
      for(let month = 1;month<=12;month++){
        if(monthValues[month]){
          result.push(monthValues[month]);
        } else {
          result.push(0);
        }
      }
      return result;
    }


    buildChildren(list: ProfitReportStandardDto[], all: ProfitReportStandardDto[]) {
      if (!list || !list.length) {
        return null
      }

      let result: {[key:string]:ItemDetail} = {};

      list.forEach((currentItem) => {
        let itemDetails: any;
        if (result[currentItem.itemName!]) {
          itemDetails = result[currentItem.itemName!];
        } else {
          itemDetails = {
            monthValues: {},
            children: {},
            totalAmount: 0
          };
          result[currentItem.itemName!]= itemDetails;
        }

        itemDetails.monthValues[currentItem.month!] = currentItem.value;
        itemDetails.totalAmount += currentItem.value;

        const currentItemChildren = all.filter(s=>s.parentId === currentItem.id);
        if(currentItemChildren && currentItemChildren.length){
          const children = this.buildChildren(all.filter(s => s.parentId === currentItem.id), all);

          itemDetails.children = this.mergeData(itemDetails.children,children);
        }



      });

      return result;

    }

    mergeData(target:any,source:any){
      // 把source的数据并到target
      if(!source){
        return target??{};
      }
      if(!target){
        return source??{};
      }

      for(let sourceKey in source){
        let sourceValue = source[sourceKey];
        let targetValue = target[sourceKey];

        if(typeof sourceValue === 'object'){
          if(typeof targetValue ==='object'){

            let newObject = this.mergeData(targetValue,sourceValue);
            target[sourceKey] = newObject;

          } else {
            let value = sourceValue;
            target[sourceKey] = value;
          }
        } else {
          let value = sourceValue??targetValue;
          target[sourceKey] = value;
        }

      }

      return target;

    }


  }
